import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from "raviger";
import { Field, Form, Formik } from 'formik';
import { Switch } from 'formik-mui';
import {
  Form as BootstrapForm,
  Button,
  ButtonGroup,
  Card,
  Col,
  ListGroup,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import * as Yup from 'yup';
import RangeSlider from 'react-bootstrap-range-slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
  faClipboardList, faPlusSquare,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';
import Header from '../components/Header';
import { Checkbox, DateTimePicker, DropDown, TextInput, ToggleSwitch } from '../components/Form';
import { statusChoices, statusChoicesDNSF, statusChoicesNFA, returnRequestedStatusChoices } from '../animals/constants';
import ButtonSpinner from '../components/ButtonSpinner';
import { priorityChoices } from '../constants';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import { titleCase } from '../components/Utils';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from "../components/LoadingLink";
import { faSparkles, faSplit } from '@fortawesome/pro-solid-svg-icons';
import { catAgeChoices, dogAgeChoices, horseAgeChoices, otherAgeChoices, catColorChoices, dogColorChoices, horseColorChoices, otherColorChoices, sexChoices, dogSizeChoices, catSizeChoices, horseSizeChoices, otherSizeChoices, unknownChoices } from '../animals/constants';
import CustomSelect from "../components/CustomSelect.js";

function AnimalStatus(props) {

  const roomRef = useRef(null);
  const shelterRef = useRef(null);

  return (
    <>
    <Row>
      <Col xs={4} className="ps-0" style={{marginLeft:"-5px", paddingRight:"3px"}}>
        <DropDown
          id={`sr_updates.${props.index}.animals.${props.inception}.status`}
          name={`sr_updates.${props.index}.animals.${props.inception}.status`}
          type="text"
          className="mt-0"
          options={props.animal.id_for_incident && props.statusOptions && Object.keys(props.statusOptions).length && props.statusOptions[props.animal.id_for_incident] ? props.statusOptions[props.animal.id_for_incident] : props.animal.original_id_for_incident && props.statusOptions && Object.keys(props.statusOptions).length && props.statusOptions[props.animal.original_id_for_incident] ? props.statusOptions[props.animal.original_id_for_incident] : statusChoices}
          value={`sr_updates.${props.index}.animals.${props.inception}.status`}
          key={`sr_updates.${props.index}.animals.${props.inception}.status`}
          isClearable={false}
          onChange={(instance) => {
            props.formikProps.setFieldValue(`sr_updates.${props.index}.animals.${props.inception}.status`, instance === null ? '' : instance.value);
            props.formikProps.setFieldValue(`sr_updates.${props.index}.animals.${props.inception}.shelter`, '');
            if (shelterRef.current) shelterRef.current.clearValue();
            // Hack to proprly update Cannot Remain Reported error display.
            if (instance.value.includes('REPORTED')) {
              props.formikProps.setFieldTouched(`sr_updates.${props.index}.animals.${props.inception}.status`)
            }
            if (instance && (instance.value === 'DID NOT SEARCH FOR')) {
              props.formikProps.setFieldValue(`sr_updates.${props.index}.followup_date`, props.service_request_object.followup_date);
            }
          }}
          disabled={props.formikProps.values.sr_updates[props.index] && props.formikProps.values.sr_updates[props.index].date_completed ? true : false}
        />
      </Col>
      <Col xs="5" style={{ marginTop:"-3px", marginBottom: "-4px", marginRight:"4px", fontSize: "26px", whiteSpace:"nowrap"}}>
        {props.animal.id_for_incident ? <span>A#{props.animal.id_for_incident} - </span> : ""}{props.animal.animal_count > 1 ? <span>{props.animal.animal_count} <span style={{textTransform:"capitalize"}}>{props.animal.species}</span></span> : <span>{props.animal.name||"Unknown Name"}&nbsp;-&nbsp;{titleCase(props.animal.species)}</span>}
        {props.animal.is_new ?
          <OverlayTrigger
            key={"animal-is-new"}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-animal-is-new`}>
                This animal was added to the Service Request while it was already assigned to this active Field Assignment.
              </Tooltip>
            }
          >
            <FontAwesomeIcon icon={faSparkles} className="ms-1" size="sm" inverse />
          </OverlayTrigger>
        : ""}
        <OverlayTrigger
          key={"animal-details"}
          placement="top"
          overlay={
            <Tooltip id={"tooltip-animal-details"} style={{textTransform: "capitalize"}}>
              Gender: {props.animal.sex ? props.animal.sex : "N/A"} <br />
              Size: {props.animal.size ? props.animal.size : "N/A"} <br />
              Color: {props.animal.pcolor ? props.animal.pcolor : "N/A"}{props.animal.scolor ? "/" + props.animal.scolor : ""} <br />
              Breed/Description: {props.animal.color_notes ? props.animal.color_notes : "N/A"} <br />
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faClipboardList} className="ms-1" inverse />
        </OverlayTrigger>
        {!props.animal.id_for_incident ? <OverlayTrigger
          key={"remove-animal"}
          placement="top"
          overlay={
            <Tooltip id={"tooltip-remove-animal"} style={{textTransform: "capitalize"}}>
              Remove added animal
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faTimes} onClick={() => {
            let sr_updates_copy = [...props.formikProps.values.sr_updates];
            sr_updates_copy[props.index].animals.splice(props.inception, 1);
            // If this is a split animal, add the animal count back to the original animal count.
            if (props.animal.original_id) {
              let animal_count = Number(sr_updates_copy[props.index].animals.filter(animal => animal.id === props.animal.original_id)[0].animal_count) + Number(props.animal.animal_count);
              sr_updates_copy[props.index].animals.filter(animal => animal.id === props.animal.original_id)[0].species = props.species.filter(species => (species.name === props.animal.species) || (species.plural_name === props.animal.species))[0].plural_name;
              sr_updates_copy[props.index].animals.filter(animal => animal.id === props.animal.original_id)[0].animal_count = animal_count;
            }
            props.setData(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
            props.formikProps.setValues(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
          }} className="ms-2" style={{cursor:'pointer'}} inverse />
        </OverlayTrigger> : ""}
      </Col>
      {props.animal.animal_count > 1 && props.animal.id && !(props.formikProps.values.sr_updates[props.index] && props.formikProps.values.sr_updates[props.index].visit_complete) ?
        <Col xs="1" className="pe-0" style={{marginTop:"-2px"}}>
          <ActionsDropdown variant="secondary" title="Actions" className="pt-0 mb-n2 me-n3 float-end">
            <LoadingLink label="Split Animal Group" onClick={() => {props.setShowSplit(true);props.setSelectedIndex(props.index);props.setSelectedInception(props.inception);props.setSelectedAnimal(props.animal)}} isLoading={false} className="d-block">
              <FontAwesomeIcon icon={faSplit} className="fas" style={{cursor:'pointer'}} size="lg" inverse />
            </LoadingLink>
          </ActionsDropdown>
        </Col> : ""}
    </Row>
    {props.formikProps.values && props.formikProps.values.sr_updates[props.index] && props.formikProps.values.sr_updates[props.index].animals[props.inception] && props.formikProps.values.sr_updates[props.index].animals[props.inception].status === 'SHELTERED' ?
    <Row>
      <Col xs={4} className="ps-0 me-2" style={{marginLeft:"-5px", paddingRight:"3px"}}>
        <DropDown
          id={`sr_updates.${props.index}.animals.${props.inception}.shelter`}
          name={`sr_updates.${props.index}.animals.${props.inception}.shelter`}
          type="text"
          ref={shelterRef}
          className="mt-3"
          options={props.shelters.options}
          value={`sr_updates.${props.index}.animals.${props.inception}.shelter`}
          isClearable={false}
          placeholder="Select Shelter..."
          onChange={(instance) => {
            props.formikProps.setFieldValue(`sr_updates.${props.index}.animals.${props.inception}.room`, '');
            props.formikProps.setFieldValue(`sr_updates.${props.index}.animals.${props.inception}.shelter`, instance === null ? '' : instance.value);
            roomRef.current.clearValue();
          }}
          disabled={props.formikProps.values.sr_updates[props.index] && props.formikProps.values.sr_updates[props.index].date_completed ? true : false}
        />
      </Col>
      <Col xs={6} className="ps-0" style={{paddingRight:"3px"}}>
        <DropDown
          id={`sr_updates.${props.index}.animals.${props.inception}.room`}
          name={`sr_updates.${props.index}.animals.${props.inception}.room`}
          type="text"
          ref={roomRef}
          className="mt-3"
          options={props.shelters.room_options[props.formikProps.values.sr_updates[props.index].animals[props.inception].shelter] ? props.shelters.room_options[props.formikProps.values.sr_updates[props.index].animals[props.inception].shelter] : []}
          isClearable={true}
          placeholder="Select Room..."
          value={`sr_updates.${props.index}.animals.${props.inception}.room`}
          onChange={(instance) => {
            props.formikProps.setFieldValue(`sr_updates.${props.index}.animals.${props.inception}.room`, instance === null ? '' : instance.value);
          }}
          disabled={props.formikProps.values.sr_updates[props.index] && props.formikProps.values.sr_updates[props.index].date_completed ? true : false}
        />
      </Col>
    </Row>
    : ""}
    </>
  )
}

function DispatchResolutionForm({ id, requestid, incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  // Initial DA data.
  const [data, setData] = useState({
    id: null,
    // closed: false,
    team_members: [],
    team_member_objects: [],
    team: null,
    team_object: {name:''},
    service_requests: [],
    assigned_requests: [],
    start_time: null,
    end_time: null,
    dispatch_date: null,
    sr_updates: [],
    incident_slug: incident,
    organization_slug: organization,
  });

  const [showSplit, setShowSplit] = useState(false);
  const handleCloseSplit = () => setShowSplit(false);

  const [shelters, setShelters] = useState({options: [], room_options: {}, isFetching: false});
  const [ownerChoices, setOwnerChoices] = useState({});
  const [saveClose, setSaveClose] = useState(false);
  const [statusOptions, setStatusOptions] = useState({});
  const [species, setSpecies] = useState({options: [], data: []});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedInception, setSelectedInception] = useState(null);
  const [selectedSR, setSelectedSR] = useState(null);
  const [selectedAnimal, setSelectedAnimal] = useState({'id':null, 'animal_count':1, 'species':''});

  const pcolorRef = useRef(null);
  const scolorRef = useRef(null);
  const sexRef = useRef(null);
  const sizeRef = useRef(null);
  const ageChoices = {'':[], 'dog':dogAgeChoices, 'cat':catAgeChoices, 'horse':horseAgeChoices, 'other':otherAgeChoices}
  const colorChoices = {'':[], 'dog':dogColorChoices, 'cat':catColorChoices, 'horse':horseColorChoices, 'other':otherColorChoices}
  const sizeChoices = {'':[], 'dog':dogSizeChoices, 'cat':catSizeChoices, 'horse':horseSizeChoices, 'other':otherSizeChoices}
  const [placeholder, setPlaceholder] = useState("Select a species...");

  const [showAddNew, setShowAddNew] = useState(false);
  const [newData, setNewData] = useState({'name': '', sex:'', age:'', size:'', 'animal_count':1, 'species':'', 'pcolor':'', 'scolor':'', 'behavior_notes':'', 'color_notes':'', 'medical_notes':'', aggressive:'unknown', aco_required:'unknown', injured:'unknown', confined:'unknown', fixed:'unknown', request:null})
  const handleCloseAddNew = () => setShowAddNew(false);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchEvacAssignmentData = () => {
      // Fetch Evac Assignment data.
      axios.get('/evac/api/incident/' + state.incident.id + '/evacassignment/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let ownerChoices = {};
          let status_data = {};
          response.data["sr_updates"] = [];
          response.data["assigned_requests"] = response.data.assigned_requests.filter(assigned_request => Number(assigned_request.service_request_object.id_for_incident) === Number(requestid))
          response.data.assigned_requests.forEach((assigned_request, index) => {
            ownerChoices[assigned_request.service_request_object.id] = []
            assigned_request.service_request_object.owner_objects.forEach(owner => {
              ownerChoices[assigned_request.service_request_object.id].push({value: owner.id, label: owner.first_name + ' ' + owner.last_name})
            })
            // Identify fixed status options based on initial status.
            Object.keys(assigned_request.animals).forEach((animal_dict) => {
              const animal = assigned_request.animals[animal_dict]

              if (['UNABLE TO LOCATE', 'NO FURTHER ACTION'].includes(animal.status)) {
                status_data[animal.id_for_incident] = statusChoicesNFA

              } else if (['TRANSPORT REQUESTED', 'CARE TRANSFERRED'].includes(animal.status)) {
                status_data[animal.id_for_incident] = returnRequestedStatusChoices

              } else if (
                ['SHELTERED IN PLACE', 'SHELTERED', 'DECEASED', 'REUNITED']
                  .includes(animal.status)
              ) {
                status_data[animal.id_for_incident] = statusChoices

              } else {
                status_data[animal.id_for_incident] = statusChoicesDNSF
              }
            })
            response.data.sr_updates.push({
              id: assigned_request.service_request_object.id,
              followup_date: assigned_request.followup_date ? String(assigned_request.followup_date).includes('T') ? assigned_request.followup_date.slice(0, 10) : assigned_request.followup_date : null,
              priority: assigned_request.service_request_object.priority,
              date_completed: assigned_request.visit_note && assigned_request.visit_note.date_completed ? assigned_request.visit_note.date_completed : null,
              visit_complete: assigned_request.visit_note && assigned_request.visit_note.date_completed ? true : false,
              directions: assigned_request.service_request_object.directions ? assigned_request.service_request_object.directions : '',
              notes: assigned_request.visit_note ? assigned_request.visit_note.notes : '',
              forced_entry: assigned_request.visit_note ? assigned_request.visit_note.forced_entry : false,
              owner_contacted: assigned_request.owner_contacted ? assigned_request.owner_contacted : false,
              status: assigned_request.service_request_object.status ? assigned_request.service_request_object.status : 'open',
              animals: Object.keys(assigned_request.animals).map(animal_id =>{return {
                id:animal_id,
                id_for_incident:assigned_request.animals[animal_id].id_for_incident,
                animal_count:assigned_request.animals[animal_id].animal_count,
                name:assigned_request.animals[animal_id].name,
                age:assigned_request.animals[animal_id].age,
                sex:assigned_request.animals[animal_id].sex,
                size:assigned_request.animals[animal_id].size,
                species:assigned_request.animals[animal_id].species,
                status:assigned_request.animals[animal_id].status,
                color_notes:assigned_request.animals[animal_id].color_notes,
                pcolor:assigned_request.animals[animal_id].pcolor,
                scolor:assigned_request.animals[animal_id].scolor,
                animal_notes:assigned_request.animals[animal_id].animal_notes,
                medical_notes:assigned_request.animals[animal_id].medical_notes,
                aggressive:assigned_request.animals[animal_id].aggressive,
                confined:assigned_request.animals[animal_id].confined,
                fixed:assigned_request.animals[animal_id].fixed,
                aco_required:assigned_request.animals[animal_id].aco_required,
                injured:assigned_request.animals[animal_id].injured,
                request:assigned_request.service_request_object.id,
                shelter:assigned_request.animals[animal_id].shelter || '',
                room:assigned_request.animals[animal_id].room || '',
                is_new:assigned_request.animals[animal_id].is_new,}}),
              owner: assigned_request.service_request_object.owners.length > 0,
              // owner_contact_id: assigned_request.owner_contact ? assigned_request.owner_contact.owner : '',
              // owner_contact_time: assigned_request.owner_contact ? assigned_request.owner_contact.owner_contact_time : null,
              // owner_contact_note: assigned_request.owner_contact ? assigned_request.owner_contact.owner_contact_note : '',
            });
          });
          setOwnerChoices(ownerChoices);
          setData(response.data);
          setStatusOptions(status_data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };

    const fetchShelters = () => {
      setShelters({options: [], room_options: [], isFetching: true});
      // Fetch Shelter data.
      axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          let room_options = {};
          response.data.forEach(shelter => {
            options.push({value: shelter.id, label: shelter.name});
            room_options[shelter.id] = [];
            shelter.buildings.forEach(building => {
              building.rooms.forEach(room => {
                // Build room option list identified by shelter ID.
                room_options[shelter.id].push({value: room.id, label: room.building_name + ' - ' + room.name + ' (' + (room.animal_count || 0) + ' animals)'});
              });
            });
          });
          setShelters({options: options, room_options: room_options, isFetching: false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: [], room_options: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };

    fetchEvacAssignmentData();
    fetchShelters();

    const fetchSpecies = () => {
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let species_options = [];
          response.data.forEach(result => {
            // Build species option list.
            species_options.push({value: result.id, label: result.name});
          });
          setSpecies({options: species_options, data: response.data});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchSpecies();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id, incident]);

  return (
    <>
    <Formik
      initialValues={data}
      enableReinitialize={true}
      validationSchema={Yup.object({
        start_time: Yup.date(),
        end_time: Yup.date().nullable(),
        service_requests: Yup.array(),
        team_members: Yup.array(),
        sr_updates: Yup.array().of(
          Yup.object().shape({
            id: Yup.number().required(),
            owner: Yup.boolean(),
            // visit_complete: Yup.boolean(),
            priority: Yup.number(),
            directions: Yup.string().max(2000, 'Must be 2000 characters or less'),
            status: Yup.string()
              .test('required-check', 'Service Request status is required',
                function(value) {
                  let required = true;
                  data.sr_updates.filter(sr => sr.id === this.parent.id).forEach(sr_update => {
                    if (sr_update.animals.length) {
                      required = false;
                    }
                  })
                  if ((!value) && required) {
                    return false;
                  }
                  return true;
                }),
            followup_date: Yup.date().nullable().test('required-check', 'Followup date is required',
                function(value) {
                  if (this.parent.date_completed) {
                    // Field is required unless all animals are in a final state.
                    if (this.parent.animals.length && this.parent.animals.filter(animal => ['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'CARE TRANSFERRED', 'DECEASED'].includes(animal.status)).length === this.parent.animals.length) {
                      return true;
                    }
                    // If this is a support SR, field is required unless status is set to closed.
                    else if (!this.parent.animals.length && this.parent.status === 'closed') {
                      return true;
                    }
                    else {
                      return value != null; // Valid if the value is not null
                    }
                  }
                  return true
                }
              ),
            animals: Yup.array().of(
              Yup.object().shape({
                id: Yup.number().nullable(),
                status: Yup.string(),
                  // .test('required-check', 'Animal cannot remain REPORTED.',
                  //   function(value) {
                  //     let required = true;
                  //     data.sr_updates.filter(sr => sr.id === this.parent.request).forEach(sr_update => {
                  //     })
                  //     if (!saveClose) {
                  //       required = false;
                  //     }
                  //     if ((value && value.includes('REPORTED') && required)) {
                  //       return false;
                  //     }
                  //     return true;
                  //   }),
                shelter: Yup.number()
                  .nullable()
                  .when('status', {
                    is: (status) => status === 'SHELTERED',
                    then: (schema) =>
                      schema
                        .required('Shelter is required when animal is sheltered'),
                    otherwise: (schema) => schema.nullable(),
                  }),
                room: Yup.number().nullable(),
              })
            ),
            date_completed: Yup.date().nullable(),
            notes: Yup.string().max(2500, 'Must be 2500 characters or less'),
            forced_entry: Yup.boolean(),
            owner_contacted: Yup.boolean(),
            // owner_contact_id: Yup.number().nullable(),
            // owner_contact_time: Yup.date().nullable(),
            // owner_contact_note: Yup.string(),
          })
        ),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          // values['closed'] = values.sr_updates[index] && values.sr_updates[index].visit_note.date_completed;
          values['incident_slug'] = incident;
          values['organization_slug'] = organization;
          // Clean out dummy value for Did Not Search For
          values.sr_updates.forEach((sr, index) => {
            sr.animals.forEach((animal, inception) => {
              values.sr_updates[index].animals[inception].status = animal.status.replace("$", "");
            })
          })
          axios.put('/evac/api/evacassignment/' + data.id + '/?incident=' + incident + '&organization=' + organization, values)
            .then(response => {
              if (response.data.service_requests.length === 0) {
                navigate('/' + organization + '/' + incident + '/field');
              }
              else {
                navigate('/' + organization + '/' + incident + '/field/summary/' + id);
              }
            })
            .catch(error => {
              setSubmitting(false);
              setShowSystemError(true);
            });
        }, 500);
      }}
    >
      {props => (
        <>
          <BootstrapForm as={Form}>
            <Header><span id="back" style={{ cursor: 'pointer' }} onClick={() => navigate("/" + organization + "/" + incident + "/field/summary/" + id)} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} inverse /></span>{data.assigned_requests.length > 0 && data.assigned_requests[0].visit_note && data.assigned_requests[0].visit_note.date_completed ? "Update" : "Add"} Visit Information</Header>
            <Card className="mt-3 border rounded">
              <Card.Body>
                <Card.Title>
                  <h4>Team: {data.team_name || 'N/A'}</h4>
                </Card.Title>
                <p className="phr" />
                <ListGroup variant="flush" style={{ marginTop:"-13px", marginBottom:"-13px", textTransform: "capitalize" }}>
                  {data.team && data.team_object.team_member_objects.map(team_member => (
                    <ListGroup.Item key={team_member.id} style={{marginLeft:"-5px"}}>
                      {team_member.first_name + " " + team_member.last_name}{team_member.agency_id ? <span>&nbsp;({team_member.agency_id})</span> : ""}
                    </ListGroup.Item>
                  ))}
                  {data.team && data.team_object.team_member_objects.length === 0 ?
                    <ListGroup.Item style={{marginLeft:"-5px"}}>
                      No Team Members Assigned
                    </ListGroup.Item> : ""
                  }
                </ListGroup>
              </Card.Body>
            </Card>
            {data.assigned_requests.map((assigned_request, index) => (
              <Card key={assigned_request.service_request_object.id} className="mt-3 border rounded">
                <Card.Body>
                  <Card.Title style={{marginBottom:"-5px", marginTop:"-5px"}}>
                    <h4>
                      SR#{assigned_request.service_request_object.id_for_incident} -&nbsp;
                      <Link href={"/" + organization + "/" + incident + "/hotline/servicerequest/" + assigned_request.service_request_object.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>{assigned_request.service_request_object.full_address}</Link>
                    </h4>
                  </Card.Title>
                  <p className="phr" />
                  <ListGroup variant="flush" style={{ marginTop: "-13px", marginBottom: "-13px" }}>
                    {assigned_request.service_request_object.owner_objects.map(owner => (
                      <ListGroup.Item key={owner.id}><b>Owner: </b>{owner.first_name} {owner.last_name}</ListGroup.Item>
                    ))}
                    {assigned_request.service_request_object.owners.length < 1 ? <ListGroup.Item><b>Owner: </b>No Owner</ListGroup.Item> : ""}
                    {/* <ListGroup.Item>
                      <Row>
                        <Col xs={2}>
                          <b>Accessible: </b>{ assigned_request.service_request_object.accessible ? "Yes" : "No"}
                        </Col>
                        <Col xs={2}>
                          <b>Turn Around: </b>{ assigned_request.service_request_object.turn_around ? "Yes" : "No"}
                        </Col>
                      </Row>
                    </ListGroup.Item> */}
                  </ListGroup>
                  <p className="phr" />
                  <Row className="mt-2">
                    <TextInput
                      id={`sr_updates.${index}.notes`}
                      name={`sr_updates.${index}.notes`}
                      xs="10"
                      as="textarea"
                      rows={5}
                      label="Visit Notes"
                      disabled={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? true : false}
                    />
                  </Row>
                  {assigned_request.service_request_object.visit_notes.length ? <ListGroup className="ms-0 ps-0" variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                  {assigned_request.service_request_object.visit_notes.map(visit_note =>
                    <ListGroup.Item key={visit_note.id} className="ms-0 ps-0" style={{whiteSpace:"pre-line"}}>
                      <b><Moment format="l">{visit_note.date_completed}</Moment>: </b>{visit_note.notes || "No information available."}
                    </ListGroup.Item>
                  ) || "None"}
                  </ListGroup> : ""}
                  <ListGroup variant="flush" style={{ marginTop:"15px", marginBottom:"-13px" }}>
                    <label style={{ marginBottom: data.sr_updates[index] && data.sr_updates[index].animals.length > 0 ? "-2px" : "5px" }}>Animals
                      {!(props.values.sr_updates[index] && props.values.sr_updates[index].visit_complete) ? <OverlayTrigger
                        key={"add-new-animal"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-add-new-animal`}>
                            Add a new animal to this field assignment
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faPlusSquare} onClick={() => {setShowAddNew(true);setSelectedSR(assigned_request.service_request_object.id);setSelectedIndex(index)}} style={{cursor:'pointer'}} className='ms-1' inverse />
                      </OverlayTrigger> : ""}
                    </label>
                    {data.sr_updates[index] && data.sr_updates[index].animals.filter(animal => animal.status !== 'CANCELED').map((animal, inception) => (
                      <ListGroup.Item key={inception}>
                        <AnimalStatus formikProps={props} sr_updates={data.sr_updates} setData={setData} setSelectedIndex={setSelectedIndex} setSelectedInception={setSelectedInception} setSelectedAnimal={setSelectedAnimal} setShowSplit={setShowSplit} showAddNew={showAddNew} setShowAddNew={setShowAddNew} index={animal.index ? animal.index : index} inception={inception} animal={animal} service_request_object={assigned_request.service_request_object} shelters={shelters} species_options={species.options} species={species.data} statusOptions={statusOptions} />
                      </ListGroup.Item>
                    ))}
                    {data.sr_updates[index] && data.sr_updates[index].animals.length === 0 ? <ListGroup.Item style={{ marginTop:"-8px"}}>None</ListGroup.Item> : ""}
                  </ListGroup>
                  <p className="phr" />
                  <Row className="mt-3">
                    <TextInput
                      id={`sr_updates.${index}.directions`}
                      name={`sr_updates.${index}.directions`}
                      xs="10"
                      as="textarea"
                      rows={5}
                      label="Instructions for Field Team"
                      disabled={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? true : false}
                    />
                  </Row>
                  <Row className="mt-3" style={{marginBottom:"-5px"}}>
                    <ToggleSwitch name={`sr_updates.${index}.forced_entry`} id={`sr_updates.${index}.forced_entry`} label="Forced Entry" disabled={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? true : false} />
                    {assigned_request.service_request_object.owners.length > 0 ?
                      <ToggleSwitch xs={4} name={`sr_updates.${index}.owner_contacted`} id={`sr_updates.${index}.owner_contacted`} label="Owner Notified of Outcome" disabled={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? true : false} />
                    : ""}
                  </Row>
                  <p className="phr" />
                  <Row className="gx-2">
                    <Col xs={3} style={{marginRight:"-25px"}}>
                      <Checkbox
                        id={`sr_updates.${index}.visit_complete`}
                        name={`sr_updates.${index}.visit_complete`}
                        top_label={"Mark Visit as Complete"}
                        checked={props.values.sr_updates[index] ? props.values.sr_updates[index].visit_complete : false}
                        style={{
                          transform: "scale(2.25)",
                        }}
                        disabled={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? false : props.values.sr_updates[index] && (props.values.sr_updates[index].animals.length > 0 && (props.values.sr_updates[index].animals.filter(animal => animal.status.includes('REPORTED')).length > 0 || props.values.sr_updates[index].animals.filter(animal => animal.status.includes('TRANSPORT REQUESTED')).length > 0))}
                        disabled_text={props.values.sr_updates[index] && props.values.sr_updates[index].animals.length > 0 && (props.values.sr_updates[index].animals.filter(animal => animal.status.includes('REPORTED')).length > 0 || props.values.sr_updates[index].animals.filter(animal => animal.status.includes('TRANSPORT REQUESTED')).length > 0) ? "Animals cannot remain REPORTED or TRANSPORT REQUESTED." : "Service Request cannot remain Assigned"}
                        onChange={() => {
                          props.setFieldValue(`sr_updates.${index}.visit_complete`, !props.values.sr_updates[index].visit_complete);
                          props.setFieldValue(`sr_updates.${index}.priority`, data.sr_updates[index].priority);
                          props.setFieldValue(`sr_updates.${index}.date_completed`, props.values.sr_updates[index].visit_complete ? null : new Date());
                          props.setFieldValue(`sr_updates.${index}.followup_date`, props.values.sr_updates[index].followup_date ? props.values.sr_updates[index].followup_date : null);
                          if (props.values.sr_updates[index].visit_complete) {
                            props.setFieldValue(`sr_updates.${index}.status`, 'assigned');
                          }
                          else if (props.values.sr_updates[index] && props.values.sr_updates[index].animals.length && props.values.sr_updates[index].animals.filter(animal => ['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'CARE TRANSFERRED', 'DECEASED'].includes(animal.status)).length === props.values.sr_updates[index].animals.length) {
                            props.setFieldValue(`sr_updates.${index}.status`, 'closed');
                          }
                          else {
                            props.setFieldValue(`sr_updates.${index}.status`, 'open');
                          }
                        }}
                        values={props.values}
                        index={index}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3 gx-2">
                    <Col xs={"4"}>
                      <DropDown
                        label="Priority"
                        id={`sr_updates.${index}.priority`}
                        name={`sr_updates.${index}.priority`}
                        type="text"
                        key={`my_unique_priority_select_key__${props.values.priority}`}
                        options={priorityChoices}
                        value={props.values.sr_updates[index] ? props.values.sr_updates[index].priority : 2}
                        isClearable={false}
                        onChange={(instance) => {
                          props.setFieldValue(`sr_updates.${index}.priority`, instance === null ? '' : instance.value);
                        }}
                        disabled={props.values.sr_updates[index] ? !props.values.sr_updates[index].date_completed : true}
                        disabled_text="Priority cannot be modified until the visit has been marked as complete."
                      />
                    </Col>
                    <DateTimePicker
                      label="Date Completed"
                      name={`sr_updates.${index}.date_completed`}
                      id={`sr_updates.${index}.date_completed`}
                      xs="4"
                      data-enable-time={false}
                      clearable={false}
                      onChange={(date, dateStr) => {
                        props.setFieldValue(`sr_updates.${index}.visit_complete`, dateStr)
                      }}
                      disabled={props.values.sr_updates[index] ? !props.values.sr_updates[index].date_completed : true}
                      disabled_text="Date completed cannot be modified until the visit has been marked as complete."
                      value={props.values.sr_updates[index] ? props.values.sr_updates[index].date_completed : null}
                      col_style={{minWidth:"297px"}}
                    />
                  </Row>
                  <Row className="mt-3 gx-2">
                      {/* <Col xs={3} style={{marginRight:"-25px"}} /> */}
                      <Col xs={"4"}>
                        <DropDown
                          label="Service Request Status"
                          id={`sr_updates.${index}.status`}
                          name={`sr_updates.${index}.status`}
                          type="text"
                          key={`my_unique_status_select_key__${props.values.status}`}
                          options={props.values.sr_updates[index] && props.values.sr_updates[index].date_completed ? props.values.sr_updates[index] && props.values.sr_updates[index].animals.length && props.values.sr_updates[index].animals.filter(animal => ['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'CARE TRANSFERRED', 'DECEASED'].includes(animal.status)).length === props.values.sr_updates[index].animals.length ? [{label:"Keep Open", value:"open"}, {label:"Close", value:"closed"}] : [{label:"Keep Open", value:"open"}] : [{label:"Assigned", value:"assigned"}]}
                          value={props.values.sr_updates[index] ? props.values.sr_updates[index].status : "open"}
                          isClearable={false}
                          onChange={(instance) => {
                            props.setFieldValue(`sr_updates.${index}.status`, instance === null ? '' : instance.value);
                          }}
                          disabled={props.values.sr_updates[index] && props.values.sr_updates[index].animals.filter(animal => animal.status === 'DID NOT SEARCH FOR').length > 0 || (props.values.sr_updates[index] ? !props.values.sr_updates[index].date_completed : true)}
                          disabled_text={"Service request status cannot be modified until the visit has been marked as complete."}
                        />
                      </Col>
                      <DateTimePicker
                        label={`Followup Date (Default: ${state.incident.default_followup_days} day${state.incident.default_followup_days === 1 ? '' : 's'})`}
                        name={`sr_updates.${index}.followup_date`}
                        id={`sr_updates.${index}.followup_date`}
                        // more_options={{minDate:'today'}}
                        xs="4"
                        data-enable-time={false}
                        clearable={false}
                        default={true}
                        default_days={state.incident.default_followup_days}
                        onChange={(date, dateStr) => {
                          props.setFieldValue(`sr_updates.${index}.followup_date`, dateStr)
                        }}
                        value={props.values.sr_updates[index] && props.values.sr_updates[index].followup_date ? props.values.sr_updates[index].followup_date : null}
                        disabled={props.values.sr_updates[index] && ((props.values.sr_updates[index].status === 'closed') || (props.values.sr_updates[index].animals.length && props.values.sr_updates[index].animals.filter(animal => animal.status === 'DID NOT SEARCH FOR').length > 0) || (props.values.sr_updates[index] ? !props.values.sr_updates[index].date_completed : true))}
                        disabled_text={props.values.sr_updates[index] && !props.values.sr_updates[index].date_completed ? "Followup date cannot be modified until the visit has been marked as complete." : props.values.sr_updates[index] && props.values.sr_updates[index].animals.filter(animal => animal.status === 'DID NOT SEARCH FOR').length > 0 ? "Followup date cannot be modified if an animal is marked as Did Not Search For." : "Followup date is no longer required for this Service Request."}
                        setFieldValue={props.setFieldValue}
                        col_style={{minWidth:"297px"}}
                      />
                  </Row>
                </Card.Body>
              </Card>
            ))}
            <ButtonGroup size="lg" className="col-12 ps-0 pe-0 mb-3" style={{marginTop:"-1px"}}>
              <ButtonSpinner isSubmitting={props.isSubmitting} isSubmittingText="Saving..." className="btn btn-block border" type="submit" onClick={() => { setSaveClose(false); }}>
                Save
              </ButtonSpinner>
            </ButtonGroup>
          </BootstrapForm>
          <Formik
            initialValues={newData}
            enableReinitialize={true}
            validationSchema={Yup.object({
              name: Yup.string(),
              animal_count: Yup.number(),
              species: Yup.string(),
              pcolor: Yup.string(),
              scolor: Yup.string(),
              behavior_notes: Yup.string().max(400, 'Must be 400 characters or less'),
            })}
            onSubmit={(values, { setSubmitting, setValues }) => {
              let sr_updates_copy = [...props.values.sr_updates];
              sr_updates_copy[selectedIndex].animals.push({
                id:null,
                id_for_incident:null,
                animal_count:values.animal_count,
                name:values.name, //TODO
                species:Number(values.animal_count) === 1 ? values.species_string : species.data.filter(species => species.name === values.species_string)[0].plural_name,
                age:values.age,
                sex:values.sex,
                size:values.size,
                status:'REPORTED',
                pcolor:values.pcolor,
                scolor:values.scolor,
                animal_notes:values.behavior_notes,
                color_notes:values.color_notes,
                medical_notes:values.medical_notes,
                aggressive:values.aggressive,
                aco_required:values.aco_required,
                injured:values.injured,
                confined:values.confined,
                fixed:values.fixed,
                request:selectedSR,
                shelter:'',
                room:'',
                is_new:false
              });
              setData(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
              props.setValues(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
              setNewData({'name': '', sex:'', age:'', size:'', 'animal_count':1, 'species':'', 'pcolor':'', 'scolor':'', 'behavior_notes':'', 'color_notes':'', 'medical_notes':'', aggressive:'unknown', aco_required:'unknown', injured:'unknown', confined:'unknown', fixed:'unknown', request:null});
              setValues({'name': '', sex:'', age:'', size:'', 'animal_count':1, 'species':'', 'pcolor':'', 'scolor':'', 'behavior_notes':'', 'color_notes':'', 'medical_notes':'', aggressive:'unknown', aco_required:'unknown', injured:'unknown', confined:'unknown', fixed:'unknown', request:null});
              setShowAddNew(false);
            }}
          >
            {formikProps => (
            <Modal show={showAddNew} onHide={handleCloseAddNew} dialogClassName="wide-modal">
              <Modal.Header closeButton>
                <Modal.Title>Add New Animal</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="gx-2">
                  <TextInput
                    id="name"
                    name="name"
                    type="text"
                    label="Animal Name"
                    xs="4"
                  />
                  <Col xs="6" style={{textTransform:'capitalize'}}>
                    <DropDown
                      label="Species*"
                      id="speciesDropdown"
                      name="species"
                      type="text"
                      key={`my_unique_species_select_key__${formikProps.values.species}`}
                      options={species.options}
                      value={formikProps.values.species}
                      isClearable={false}
                      onChange={(instance) => {
                        setPlaceholder("Select...")
                        pcolorRef.current.clearValue();
                        scolorRef.current.clearValue();
                        formikProps.setFieldValue("species", instance.value);
                        formikProps.setFieldValue("species_string", instance.label);
                      }}
                    />
                  </Col>
                  <TextInput
                    id="animal_count"
                    name="animal_count"
                    type="text"
                    xs="2"
                    label="No. of Animals"
                  />
                </Row>
                <Row className="mt-3 gx-2">
                  <Col xs="4">
                    <DropDown
                      label="Sex"
                      id="sexDropDown"
                      name="sex"
                      type="text"
                      key={`my_unique_sex_select_key__${formikProps.values.sex}`}
                      ref={sexRef}
                      options={sexChoices}
                      value={formikProps.values.sex||''}
                    />
                  </Col>
                  <Col xs="4">
                    <CustomSelect
                      label="Age"
                      options={Object.keys(ageChoices).includes(formikProps.values.species_string)
                        ? ageChoices[formikProps.values.species_string]
                        : ageChoices['other']}
                      value={formikProps.values.age || ''}
                      handleValueChange={(value) => formikProps.setFieldValue('age', value)}
                      optionsKey={formikProps.values.species_string || ''}
                      formValidationName="age"
                    />
                  </Col>
                  <Col xs="4">
                    <DropDown
                      label="Size"
                      id="sizeDropdown"
                      name="size"
                      type="text"
                      isClearable={true}
                      key={`my_unique_size_select_key__${formikProps.values.size}`}
                      ref={sizeRef}
                      options={Object.keys(sizeChoices).includes(formikProps.values.species_string) ? sizeChoices[formikProps.values.species_string] : sizeChoices['other']}
                      value={formikProps.values.size||''}
                      placeholder={placeholder}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 gx-2">
                  <Col xs="4">
                    <DropDown
                      label="Primary Color"
                      id="pcolor"
                      name="pcolor"
                      type="text"
                      key={`my_unique_pcolor_select_key__${formikProps.values.pcolor}`}
                      ref={pcolorRef}
                      style={{marginTop:"2px"}}
                      options={Object.keys(colorChoices).includes(formikProps.values.species_string) ? colorChoices[formikProps.values.species_string] : colorChoices['other']}
                      value={formikProps.values.pcolor||''}
                      placeholder={placeholder}
                    />
                    <DropDown
                      label="Secondary Color"
                      id="scolor"
                      name="scolor"
                      type="text"
                      key={`my_unique_scolor_select_key__${formikProps.values.scolor}`}
                      ref={scolorRef}
                      style={{marginTop:"30px"}}
                      options={Object.keys(colorChoices).includes(formikProps.values.species_string) ? colorChoices[formikProps.values.species_string] : colorChoices['other']}
                      value={formikProps.values.scolor||''}
                      placeholder={placeholder}
                    />
                  </Col>
                  <TextInput
                    id="behavior_notes"
                    name="behavior_notes"
                    as="textarea"
                    rows={5}
                    label="Animal Notes"
                    xs="8"
                  />
                </Row>
                <Row className="mt-3 gx-2">
                  <Col xs="4">
                    <DropDown
                      label="Aggressive"
                      id="aggressive"
                      name="aggressive"
                      type="text"
                      options={unknownChoices}
                      value={formikProps.values.aggressive||'unknown'}
                      isClearable={false}
                      onChange={(instance) => {
                        formikProps.setFieldValue("aggressive", instance === null ? '' : instance.value);
                        formikProps.setFieldValue("aco_required", instance && instance.value === 'yes' ? 'yes' : formikProps.values.aco_required);
                      }}
                    />
                  </Col>
                  <Col xs="4">
                    <DropDown
                      label="Special Handling Required"
                      id="aco_required"
                      name="aco_required"
                      type="text"
                      options={unknownChoices}
                      value={formikProps.values.aco_required||'unknown'}
                      isClearable={false}
                    />
                  </Col>
                  <Col xs="4">
                    <DropDown
                      label="Injured"
                      id="injured"
                      name="injured"
                      type="text"
                      options={unknownChoices}
                      value={formikProps.values.injured||'unknown'}
                      isClearable={false}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 gx-2">
                  <Col xs="4">
                    <DropDown
                      label="Confined"
                      id="confined"
                      name="confined"
                      type="text"
                      options={unknownChoices}
                      value={formikProps.values.confined||'unknown'}
                      isClearable={false}
                    />
                  </Col>
                  <Col xs="4">
                    <DropDown
                      label="Altered"
                      id="fixed"
                      name="fixed"
                      type="text"
                      options={unknownChoices}
                      value={formikProps.values.fixed||'unknown'}
                      isClearable={false}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 gx-2">
                  <TextInput
                    id="color_notes"
                    name="color_notes"
                    as="textarea"
                    rows={5}
                    label="Breed / Description"
                    xs="12"
                  />
                </Row>
                <Row className="mt-3 gx-2">
                  <TextInput
                    id="medical_notes"
                    name="medical_notes"
                    as="textarea"
                    rows={5}
                    label="Medical Notes"
                    xs="12"
                  />
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Add</Button>
                <Button variant="secondary" onClick={handleCloseAddNew}>Close</Button>
              </Modal.Footer>
            </Modal>
            )}
          </Formik>
          <Formik
            initialValues={{'animal_count':selectedAnimal.animal_count, 'group_2':0, 'split_all':false, 'change_reason':''}}
            enableReinitialize={true}
            validationSchema={Yup.object({
              animal_count: Yup.number(),
              group_2: Yup.number(),
              split_all: Yup.boolean(),
              change_reason: Yup.string().max(400, 'Must be 400 characters or less'),
            })}
            onSubmit={(values, { setSubmitting, setValues }) => {
              let sr_updates_copy = [...props.values.sr_updates];
              if (values.split_all) {
                sr_updates_copy[selectedIndex].animals[selectedInception].animal_count = 1;
                sr_updates_copy[selectedIndex].animals[selectedInception].species = species.data.filter(specie_data => specie_data.plural_name === selectedAnimal.species)[0].name;
                for (let i = 0; i < values.group_2; i++) {
                  sr_updates_copy[selectedIndex].animals.push({
                    id:null,
                    id_for_incident:null,
                    index:selectedIndex,
                    original_id:selectedAnimal.id ? selectedAnimal.id : selectedAnimal.original_id,
                    original_id_for_incident:selectedAnimal.id_for_incident ? selectedAnimal.id_for_incident : selectedAnimal.original_id_for_incident,
                    animal_count:1,
                    name:'',
                    species:species.data.filter(specie_data => (specie_data.name === selectedAnimal.species || specie_data.plural_name === selectedAnimal.species))[0].name,
                    status:selectedAnimal.status,
                    color_notes:selectedAnimal.color_notes,
                    pcolor:selectedAnimal.pcolor,
                    scolor:selectedAnimal.scolor,
                    animal_notes:selectedAnimal.animal_notes,
                    aggressive:selectedAnimal.aggressive,
                    aco_required:selectedAnimal.aco_required,
                    injured:selectedAnimal.injured,
                    request:selectedSR,
                    shelter:selectedAnimal.shelter || '',
                    room:selectedAnimal.room || '',
                    is_new: selectedAnimal.is_new,
                    change_reason: values.change_reason
                  });
                }
              }
              else {
                sr_updates_copy[selectedIndex].animals[selectedInception].animal_count = values.animal_count;
                sr_updates_copy[selectedIndex].animals.push({
                  id:null,
                  id_for_incident:null,
                  index:selectedIndex,
                  original_id:selectedAnimal.id ? selectedAnimal.id : selectedAnimal.original_id,
                  original_id_for_incident:selectedAnimal.id_for_incident ? selectedAnimal.id_for_incident : selectedAnimal.original_id_for_incident,
                  animal_count:values.group_2,
                  name:'',
                  species:Number(values.group_2) === 1 ? species.data.filter(specie_data => specie_data.plural_name === selectedAnimal.species)[0].name : species.data.filter(specie_data => specie_data.plural_name === selectedAnimal.species)[0].plural_name,
                  status:selectedAnimal.status,
                  color_notes:selectedAnimal.color_notes,
                  pcolor:selectedAnimal.pcolor,
                  scolor:selectedAnimal.scolor,
                  animal_notes:selectedAnimal.animal_notes,
                  aggressive:selectedAnimal.aggressive,
                  aco_required:selectedAnimal.aco_required,
                  injured:selectedAnimal.injured,
                  request:selectedSR,
                  shelter:selectedAnimal.shelter || '',
                  room:selectedAnimal.room || '',
                  is_new: selectedAnimal.is_new,
                  change_reason: values.change_reason
                });
              }
              setData(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
              props.setValues(prevState => ({ ...prevState, "sr_updates":sr_updates_copy}));
              setShowSplit(false);
            }}
          >
            {formikProps => (
            <Modal show={showSplit} onHide={handleCloseSplit}>
              <Modal.Header closeButton>
                <Modal.Title>Split Animal Group</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{textTransform:"capitalize"}}><b>Before Split: </b><span>{selectedAnimal.animal_count} {selectedAnimal.species}</span></div>
                <Row>
                  <Col xs={2}>
                    <div className="mt-3"><label className="mb-2"><b>Split All:</b></label></div>
                    <Checkbox
                      id={'split_all'}
                      name={'split_all'}
                      checked={formikProps.values.split_all}
                      style={{
                        transform: "scale(1.50)",
                        marginLeft: "-5px",
                        marginTop: "-5px",
                        marginBottom: "-5px"
                      }}
                      onChange={() => {
                        if (!formikProps.values.split_all) {
                          formikProps.setFieldValue("animal_count", 1);
                          formikProps.setFieldValue("group_2", selectedAnimal.animal_count - 1);
                        }
                        else {
                          formikProps.setFieldValue("animal_count", selectedAnimal.animal_count);
                          formikProps.setFieldValue("group_2", 0);
                        }
                        formikProps.setFieldValue("split_all", !formikProps.values.split_all);
                      }}
                      disabled={Number(selectedAnimal.animal_count) > 10}
                      disabled_text={"Cannot split animal groups larger than 10."}
                    />
                  </Col>
                  <Col>
                    {species.data.length && selectedAnimal.id ? <div className="mt-3"><b>Number of <span style={{textTransform:"capitalize"}}>{species.data.filter(specie_data => (specie_data.name.toLowerCase() === selectedAnimal.species.toLowerCase() || specie_data.plural_name.toLowerCase() === selectedAnimal.species.toLowerCase()))[0].plural_name}</span> to Split: </b>{formikProps.values.group_2}</div> : ""}
                    <OverlayTrigger
                      key={"disabled"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-disabled`} hidden={!formikProps.values.split_all}>
                          Range slider may not be used with Split All
                        </Tooltip>
                      }
                    >
                      <RangeSlider
                        value={formikProps.values.group_2}
                        onChange={(changeEvent) => {formikProps.setFieldValue("group_2", changeEvent.target.value);formikProps.setFieldValue("animal_count", selectedAnimal.animal_count - changeEvent.target.value);}}
                        min={0}
                        max={selectedAnimal.animal_count - 1}
                        className="mb-2 mt-2"
                        disabled={formikProps.values.split_all}
                      />
                    </OverlayTrigger>
                  </Col>
                </Row>
                <div className="mt-2" style={{textTransform:"capitalize"}}><b>After Split:&nbsp;</b>{Number(formikProps.values.group_2) > 0 && !formikProps.values.split_all ? <span>{selectedAnimal.animal_count - Number(formikProps.values.group_2)}&nbsp;<span>{selectedAnimal.animal_count - Number(formikProps.values.group_2) === 1 && species.data.length > 0 && selectedAnimal.id ? species.data.filter(specie_data => (specie_data.name.toLowerCase() === selectedAnimal.species.toLowerCase() || specie_data.plural_name.toLowerCase() === selectedAnimal.species.toLowerCase()))[0].name : selectedAnimal.species}</span>, {formikProps.values.group_2}&nbsp;<span>{Number(formikProps.values.group_2) === 1 && species.data.length > 0 && data.id ? species.data.filter(specie_data => (specie_data.name.toLowerCase() === selectedAnimal.species.toLowerCase() || specie_data.plural_name.toLowerCase() === selectedAnimal.species.toLowerCase()))[0].name : selectedAnimal.species}</span></span> : formikProps.values.split_all ? Array(selectedAnimal.animal_count).fill("1 " + species.data.filter(specie_data => (specie_data.name.toLowerCase() === selectedAnimal.species.toLowerCase() || specie_data.plural_name.toLowerCase() === selectedAnimal.species.toLocaleLowerCase()))[0].name).join(", ") : <span>{selectedAnimal.animal_count} {selectedAnimal.species}</span>}</div>
                <Row className="mt-3">
                  <TextInput
                    as="textarea"
                    rows={2}
                    xs="12"
                    type="text"
                    label="Split Reason*"
                    name="change_reason"
                  />
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => {formikProps.submitForm();}} disabled={Number(formikProps.values.group_2) === 0 || !formikProps.values.change_reason}>Split</Button>
                <Button variant="secondary" onClick={handleCloseSplit}>Close</Button>
              </Modal.Footer>
            </Modal>
            )}
          </Formik>
        </>
      )}
    </Formik>
    </>
  )
}

export default DispatchResolutionForm;
